import React, { useState } from 'react';
import { journeyMilestones, journeyPhases, journeyRange, journeyRows, journeyTicks } from '../data/journey';
import { Reveal } from '../components/Reveal';
import { SectionHeading } from '../components/SectionHeading';
interface Selection {
  organization: string;
  label: string;
  period: string;
}
const pct = (year: number) => (year - journeyRange.start) / (journeyRange.end - journeyRange.start) * 100;
export function Journey() {
  const [selected, setSelected] = useState<Selection>({
    organization: 'Megalabs Chile',
    label: 'Chief Information Officer',
    period: 'Jul 2017 – Aug 2022'
  });
  return <section aria-labelledby="journey-title" className="bg-paper py-20 md:py-28" data-id="element-323" data-mp="1axo5eun3d7ow">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-324" data-mp="164v3sfmx6fh1">
        <SectionHeading id="journey-title" label="06 · Professional journey" title="A progression from engineering to the boardroom." intro="Each phase built on the one before: engineering, solutions and product, regional leadership, market development, IT direction, and governance and advisory." data-id="element-325" data-mp="ifso3dbuiwp6" />

        <Reveal className="mt-16 hidden md:block" data-id="element-326" data-mp="ww9m2z35nsod">
          <div className="relative ml-44 h-14" data-id="element-327" data-mp="11osznw1uent6">
            {journeyPhases.map(phase => {
            const width = pct(phase.end) - pct(phase.start);
            return <div key={phase.label} className="absolute top-0 flex h-full flex-col justify-end border-l border-line pb-2 pl-2" style={{
              left: `${pct(phase.start)}%`,
              width: `${width}%`
            }} data-id="element-328" data-mp="8zvftohzgiyb">
                  {width > 6 && <span className="truncate text-xs font-medium text-ink" data-id="element-329" data-mp="j05u7cfr7wf2">{phase.label}</span>}
                </div>;
          })}
          </div>

          <div className="border-t border-ink" data-id="element-330" data-mp="1uc6n93jni70m">
            {journeyRows.map(row => <div key={row.organization} className="flex items-center border-b border-line" data-id="element-331" data-mp="1ye1x4wfndsq0">
                <div className="w-44 shrink-0 py-3 pr-4 text-sm text-ink" data-id="element-332" data-mp="3veoavujiv6pw">{row.organization}</div>
                <div className="relative h-10 flex-1" data-id="element-333" data-mp="3qgwb6ecmygb5">
                  {journeyTicks.map(t => <span key={t} className="absolute inset-y-0 w-px bg-line/60" style={{
                left: `${pct(t)}%`
              }} aria-hidden="true" data-id="element-334" data-mp="8b003uvjbitn" />)}
                  {row.segments.map((seg, i) => {
                const isSel = selected.organization === row.organization && selected.label === seg.label;
                const width = pct(seg.end) - pct(seg.start);
                const select = () => setSelected({
                  organization: row.organization,
                  label: seg.label,
                  period: seg.period
                });
                return <button key={seg.label} type="button" onClick={select} onMouseEnter={select} aria-pressed={isSel} aria-label={`${seg.label}, ${row.organization}, ${seg.period}`} className={`absolute bottom-2 top-2 overflow-hidden rounded-sm border-r border-paper px-2 text-left text-xs transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-bronze focus-visible:ring-offset-1 ${isSel ? 'bg-bronze text-paper' : i % 2 ? 'bg-ink-muted text-paper hover:bg-bronze' : 'bg-ink text-paper hover:bg-bronze'}`} style={{
                  left: `${pct(seg.start)}%`,
                  width: `${width}%`
                }} data-id="element-335" data-mp="3gp8lahvq97bs" data-mpi={i}>
                        {width > 9 && <span className="block truncate leading-6" data-id="element-336" data-mp="1d8vbk621dca6">{seg.label}</span>}
                      </button>;
              })}
                </div>
              </div>)}

            <div className="flex items-center border-b border-line" data-id="element-337" data-mp="1t6kp3lnvt43">
              <div className="w-44 shrink-0 py-3 pr-4 text-sm text-slate-text" data-id="element-338" data-mp="6um64wrr41n0">Education</div>
              <div className="relative h-10 flex-1" data-id="element-339" data-mp="m3hmeh0o0v3u">
                {journeyMilestones.map(m => {
                const select = () => setSelected({
                  organization: 'Education',
                  label: m.label,
                  period: String(m.year)
                });
                return <button key={m.year} type="button" onClick={select} onMouseEnter={select} aria-label={`${m.label}, ${m.year}`} className={`absolute top-1/2 h-3 w-3 -translate-x-1/2 -translate-y-1/2 rotate-45 border transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-bronze ${selected.label === m.label ? 'border-bronze bg-bronze' : 'border-ink bg-paper hover:bg-bronze'}`} style={{
                  left: `${pct(m.year)}%`
                }} data-id="element-340" data-mp="d8jm2ov6ug2h" />;
              })}
              </div>
            </div>
          </div>

          <div className="relative ml-44 h-8" data-id="element-341" data-mp="31q64hn6iaw8h">
            {journeyTicks.map(t => <span key={t} className="absolute top-2 -translate-x-1/2 text-xs tabular-nums text-slate-text" style={{
            left: `${pct(t)}%`
          }} data-id="element-342" data-mp="36ohebxwsx6qp">
                {t}
              </span>)}
          </div>

          <div className="mt-8 flex flex-wrap items-baseline gap-x-4 gap-y-1 border-l-2 border-bronze pl-5" aria-live="polite" data-id="element-343" data-mp="3gf27v6xmbl2r">
            <p className="font-serif text-2xl text-ink" data-id="element-344" data-mp="3khgqpr1aeku1">{selected.label}</p>
            <p className="text-sm text-slate-text" data-id="element-345" data-mp="3pccl2xtzxkab">
              {selected.organization} · <span className="tabular-nums" data-id="element-346" data-mp="3uelgs1y970g4">{selected.period}</span>
            </p>
          </div>
          <p className="mt-3 text-xs text-slate-text" data-id="element-347" data-mp="35o3vtzbky0r">Hover over or select a bar to see role details.</p>
        </Reveal>

        <ol className="mt-12 border-l border-ink md:hidden" data-id="element-348" data-mp="2013ok1mwlfer">
          {journeyPhases.map(phase => <li key={phase.label} className="relative pb-8 pl-6 last:pb-0" data-id="element-349" data-mp="250gbemdrymhc">
              <span className="absolute -left-[5px] top-1.5 h-2.5 w-2.5 rotate-45 bg-bronze" aria-hidden="true" data-id="element-350" data-mp="1wyftatmozh29" />
              <p className="text-sm tabular-nums text-bronze" data-id="element-351" data-mp="1s0e5xwi8gvkz">{phase.period}</p>
              <p className="mt-1 font-serif text-xl text-ink" data-id="element-352" data-mp="26wlpculthsz7">{phase.label}</p>
              <p className="mt-1 text-sm text-slate-text" data-id="element-353" data-mp="21whilwapocm6">{phase.organizations}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}